import { CanvasPreviewSize } from '../types';

export default function savePreviewSize(size: CanvasPreviewSize): void {
  try {
    localStorage.setItem('UserPreferredDevice', JSON.stringify(size));
  } catch (err) {
    // Ignore failure to persist the selected preview size
  }
}
